"use client";

import { c as _c } from "react/compiler-runtime";
import { type FormEvent, useState } from "react";
import { useTranslation } from "react-i18next";
import { notifyError, notifySuccess } from "@/components/shared/feedback";
import { LEGACY_ICONS } from "@/components/shared/legacyIcons";
import { getApiErrorMessage } from "@/utils/apiError";
import { useForgotPasswordMutation } from "../hooks/useForgotPasswordMutation";
import { preventEnterSubmit } from "../utils/preventEnterSubmit";
import { isTooManyAttempts } from "../utils/tooManyAttempts";
import { LoginAlert } from "./LoginAlert";
import { LoginInput } from "./LoginInput";
export const ForgotPasswordForm = () => {
  const $ = _c(45);
  const {
    t
  } = useTranslation("auth");
  const [login, setLogin] = useState("");
  const [email, setEmail] = useState("");
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isAlertVisible, setIsAlertVisible] = useState(false);
  const forgotPasswordMutation = useForgotPasswordMutation();
  let t0;
  if ($[0] !== isSubmitted || $[1] !== login) {
    t0 = isSubmitted && login.trim() === "";
    $[0] = isSubmitted;
    $[1] = login;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const isLoginInvalid = t0;
  let t1;
  if ($[3] !== email || $[4] !== isSubmitted) {
    t1 = isSubmitted && email.trim() === "";
    $[3] = email;
    $[4] = isSubmitted;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const isEmailInvalid = t1;
  let t2;
  if ($[6] !== email || $[7] !== forgotPasswordMutation || $[8] !== login || $[9] !== t) {
    t2 = event => {
      event.preventDefault();
      setIsSubmitted(true);
      if (login.trim() === "" || email.trim() === "") {
        setIsAlertVisible(true);
        return;
      }
      setIsAlertVisible(false);
      forgotPasswordMutation.mutate({
        login,
        email
      }, {
        onSuccess: message => notifySuccess(message ?? t("forgotPassword.success")),
        onError: error => notifyError(isTooManyAttempts(error) ? t("tooManyAttempts") : getApiErrorMessage(error, t("common:feedback.requestError")))
      });
    };
    $[6] = email;
    $[7] = forgotPasswordMutation;
    $[8] = login;
    $[9] = t;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  const handleSubmit = t2;
  let t3;
  if ($[11] !== t) {
    t3 = t("forgotPassword.title");
    $[11] = t;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  let t4;
  if ($[13] !== t3) {
    t4 = <h3 className="mb-[25px] mt-[10px] text-2xl font-light leading-[1.1] text-[#eee]">{t3}</h3>;
    $[13] = t3;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  let t5;
  if ($[15] !== isAlertVisible || $[16] !== t) {
    t5 = isAlertVisible ? t("forgotPassword.formError") : null;
    $[15] = isAlertVisible;
    $[16] = t;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  let t6;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = () => setIsAlertVisible(false);
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  let t7;
  if ($[19] !== t5) {
    t7 = <LoginAlert message={t5} onClose={t6} />;
    $[19] = t5;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  let t8;
  if ($[21] !== t) {
    t8 = t("forgotPassword.identifier");
    $[21] = t;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  let t9;
  if ($[23] !== isLoginInvalid || $[24] !== login || $[25] !== t8) {
    t9 = <div className="mb-[15px]"><LoginInput id="recover-login" placeholder={t8} value={login} onValueChange={setLogin} icon={LEGACY_ICONS.user} isInvalid={isLoginInvalid} /></div>;
    $[23] = isLoginInvalid;
    $[24] = login;
    $[25] = t8;
    $[26] = t9;
  } else {
    t9 = $[26];
  }
  let t10;
  if ($[27] !== t) {
    t10 = t("forgotPassword.emailPlaceholder");
    $[27] = t;
    $[28] = t10;
  } else {
    t10 = $[28];
  }
  let t11;
  if ($[29] !== email || $[30] !== isEmailInvalid || $[31] !== t10) {
    t11 = <div className="mb-[15px]"><LoginInput id="recover-email" placeholder={t10} value={email} onValueChange={setEmail} icon={LEGACY_ICONS.user} isInvalid={isEmailInvalid} /></div>;
    $[29] = email;
    $[30] = isEmailInvalid;
    $[31] = t10;
    $[32] = t11;
  } else {
    t11 = $[32];
  }
  const t12 = forgotPasswordMutation.isPending;
  let t13;
  if ($[33] !== t) {
    t13 = t("forgotPassword.submit");
    $[33] = t;
    $[34] = t13;
  } else {
    t13 = $[34];
  }
  let t14;
  if ($[35] !== forgotPasswordMutation.isPending || $[36] !== t13) {
    t14 = <div className="flex justify-end pt-px"><button type="submit" disabled={t12} className="h-[34px] rounded border border-[#32c5d2] bg-[#32c5d2] px-3 text-sm text-white hover:border-[#2499a3] hover:bg-[#26a1ab] disabled:opacity-65">{t13}</button></div>;
    $[35] = forgotPasswordMutation.isPending;
    $[36] = t13;
    $[37] = t14;
  } else {
    t14 = $[37];
  }
  let t15;
  if ($[38] !== handleSubmit || $[39] !== t11 || $[40] !== t14 || $[41] !== t4 || $[42] !== t7 || $[43] !== t9) {
    t15 = <form noValidate={true} onSubmit={handleSubmit} onKeyDown={preventEnterSubmit}>{t4}{t7}{t9}{t11}{t14}</form>;
    $[38] = handleSubmit;
    $[39] = t11;
    $[40] = t14;
    $[41] = t4;
    $[42] = t7;
    $[43] = t9;
    $[44] = t15;
  } else {
    t15 = $[44];
  }
  return t15;
};